import React, {useEffect} from "react";
import {matchPath} from "react-router";
import {routes} from "../../../../../../core/models/static/routes/app-routes";
import {Redirect, Route, Switch, useHistory, useLocation} from "react-router-dom";
// legacy — restore when batches, history-items, returns, and post-transfer stepper ship
// import InventoryTransferBatchesView from "./batches";
import InventoryTransferHistoryListView from "./history-list";
// import InventoryTransferHistoryItemsView from "./history-items";
// import InventoryTransferReturnInformationView from "./return-information";
import InventoryTransferBatchInformationView from "./batch-information";
// import PostTransferView from "./post-transfer";
import useAccessLevels from "../../../../../hooks/use-access-levels";

const InventoryTransferViews = () => {
    const location = useLocation();
    const history = useHistory();
    const operatorAccessLevels = useAccessLevels();

    /**
     * Redirects the inventory transfer base route to the transfer list.
     */
    useEffect(() => {
        if (!!matchPath(location.pathname, {path: routes.inventory.inventoryTransfer.base, exact: true})) {
            if (operatorAccessLevels.packages.bizInventory.transferHistoryList) {
                history.replace(routes.inventory.inventoryTransfer.list);
            } else {
                history.replace(routes.inventory.inventoryTransfer.base.concat(routes.error.accessDeniedForSection));
            }
        }
    }, [history, location.pathname, operatorAccessLevels.packages.bizInventory.transferHistoryList]);

    return (
        <Switch>
            <Route path={routes.inventory.inventoryTransfer.base} exact/>
            {
                operatorAccessLevels.packages.bizInventory.transferInformation &&
                <Route path={routes.inventory.inventoryTransfer.single} exact>
                    <InventoryTransferBatchInformationView/>
                </Route>
            }
            {
                operatorAccessLevels.packages.bizInventory.transferHistoryList &&
                <Route path={routes.inventory.inventoryTransfer.list} exact>
                    <InventoryTransferHistoryListView/>
                </Route>
            }
            {/* legacy routes — keep registered until v2 pages ship */}
            {/* v2: restore when batches ship
            {
                operatorAccessLevels.packages.bizInventory.transferList &&
                <Route path={routes.inventory.inventoryTransfer.batches} exact>
                    <InventoryTransferBatchesView/>
                </Route>
            }
            */}
            {
                operatorAccessLevels.packages.bizInventory.transferInformation &&
                <Route path={routes.inventory.inventoryTransfer.batchInformation} exact>
                    <InventoryTransferBatchInformationView/>
                </Route>
            }
            {/* v2: restore when returns ship
            {
                operatorAccessLevels.packages.bizInventory.transferInformation &&
                <Route path={routes.inventory.inventoryTransfer.returnInformation} exact>
                    <InventoryTransferReturnInformationView/>
                </Route>
            }
            */}
            {/* v2: restore when post-transfer stepper ships
            {
                operatorAccessLevels.packages.bizInventory.submitTransfer &&
                <Route path={routes.inventory.inventoryTransfer.postTransfer} exact>
                    <PostTransferView/>
                </Route>
            }
            */}
            {
                operatorAccessLevels.packages.bizInventory.transferHistoryList &&
                <Route path={routes.inventory.inventoryTransfer.historyList} exact>
                    <InventoryTransferHistoryListView/>
                </Route>
            }
            {/* v2: restore when history-items API ships
            {
                operatorAccessLevels.packages.bizInventory.transferHistoryItems &&
                <Route path={routes.inventory.inventoryTransfer.historyItems} exact>
                    <InventoryTransferHistoryItemsView/>
                </Route>
            }
            */}
            {
                operatorAccessLevels.packages.bizInventory.transferInformation &&
                <Route path={routes.inventory.inventoryTransfer.historyInformation} exact>
                    <InventoryTransferBatchInformationView/>
                </Route>
            }
            <Redirect to={routes.inventory.inventoryTransfer.base.concat(routes.error.accessDeniedForSection)}/>
        </Switch>
    );
};

export default InventoryTransferViews;
